export const BodyFontBase = {
	size: 'p_s/600',
}

export const BodyFontLarge = {
	fontSize: '24px',
	lineHeight: '40px',
	fontWeight: 500,
}
